import { action, computed, observable, runInAction } from "mobx";
import { api } from "../../api";
import { api_adm } from "../../api";
import { FilterContas, IConta, newFilterContas } from "../../model";
import { toast } from "react-toastify";
import { sortByDesc } from "../../utils";

class _ContaStore {

  obs = observable({
    contas: [] as IConta[],
    progressDelete: false as boolean,
    usuarios: "" as string,
    nfes: "" as string,
    calculo_processado: 0 as number,
    total_espaco: "" as string,
    total_manifestado: "" as string,
    total_empresas: "" as string,
    nome_conta: "" as string,
    empresas: [] as any,
    logs: [] as any,
    empresas_planos: [] as any,
    empresas_planos_personalizados: [] as any,
    valortotal_assinatura: 0 as number,
    expiraem_assinatura: "" as string,
    empresas_retroativas: [] as any,
    open_edit_plano: false as boolean,
    ativar_empresa: false as boolean,
    conta_id: "" as string,
    filters: newFilterContas() as FilterContas,
  })

  async loadContas(page: number): Promise<void> {

    try {

      let params: any = {
        page: page,
        limit: 15,
        filters: this.obs.filters
      }

      let resp = await api_adm.post("/api/admin/contas/index", params)

      this.obs.contas = []

      this.obs.contas = resp.data

    } catch (ex) { }

  }

  @action
  async getContaPlano(id: any): Promise<void> {
    try {
      let resp_emp = await api.get(`/api/count-empresas-plano-id/${id}`);

      this.obs.empresas_planos = []
      this.obs.empresas_planos_personalizados = []

      resp_emp.data?.forEach((obj) => {

        if (obj.plano && obj.plano.default) {

          if (!this.obs.empresas_planos[`faixa${obj.plano.faixa}`]) {
            this.obs.empresas_planos[`faixa${obj.plano.faixa}`] = []
          }

          this.obs.empresas_planos[`faixa${obj.plano.faixa}`].push(obj);

        }

        if (obj.plano && !obj.plano.default && obj.plano.old_id == 4) {
          this.obs.empresas_planos_personalizados.push(obj)
        }

      });

    } catch (ex) {
      toast.error("Erro ao consultar total Empresas Plano, tente novamente mais tarde.", {});
    }
    // Status asssinatura
    try {
      let status_assinatura = await api.get(`/api/status-assinatura-id/${id}`);

      runInAction(() => {
        let total = 0;

        if (!status_assinatura.data.errors) {
          if (status_assinatura.data.subitems) {
            if (status_assinatura.data.subitems.length > 0) {
              total = 0;

              status_assinatura.data.subitems?.map(element => {
                total += element.price_cents / 100;
              });
            }
          }

          this.obs.valortotal_assinatura = total;
          this.obs.expiraem_assinatura = status_assinatura.data.expires_at
            ? status_assinatura.data.expires_at
            : "0000-00-0";
        }
      });
    } catch (ex) { }
  }

  @action
  async getContaLogs(id: any): Promise<void> {
    try {
      let resp_conta = await api_adm.get(`/api/admin/contratos/${id}`);

      this.obs.nome_conta = resp_conta.data.nome_conta;
      this.obs.logs = [];
      this.obs.logs = resp_conta.data.ret

    } catch (ex) {
      toast.error("Erro ao carregar Conta Logs, tente novamente mais tarde.", {});
    }
  }

  async handleConsultaEmpresas(conta_id: string) {
    try {
      this.obs.empresas_retroativas = []

      let resp = await api_adm.get(`/api/admin/empresas/${conta_id}`);

      this.obs.empresas_retroativas = resp.data.empresas
    } catch (ex) {
      toast.error("Erro ao consultar Empresas!", {});
    }
  }

  async handleLiberaEmpresasRetroativas(empresa_id: string, checked: boolean) {

    try {

      let data = {
        id: empresa_id,
        calcula_nota_retroativa: checked
      }

      let resp = await api_adm.put(`/api/admin/empresa-nota-retroativa`, data);

      return resp.data.ok

    } catch (ex) {

      toast.error("Erro ao liberar Empresa Retroativa!", {});

    }

    return false

  }

  async handleAtivaEmpresa(empresa_id: string) {
    try {
      let data = {
        id: empresa_id
      }

      let resp = await api_adm.put(`/api/admin/ativar-empresa`, data);

      this.obs.ativar_empresa = resp.data.ok
    } catch (ex) {
      toast.error("Erro ao ativar Empresa!", {});
    }
  }

  async handlePlanoPersonalizado(dados) {

    try {

      let data = {
        empresa_id: dados._id,
        valor: parseFloat(dados.valor),
        maximo: parseFloat(dados.maximo),
        nome: dados.plano
      }

      let resp = await api_adm.post('/api/admin/add-plano-personalizado', data)

      if (resp.data.ok) {

        toast.success('Valor Atualizado com sucesso!', {});

      } else {

        toast.error(resp.data.error, {});

      }

    } catch (ex) {

      toast.error("Erro ao criar Plano Personalizado!", {});

    }

  }

  async updateNextPlano(params: any) {
    try {

      let resp = await api.post("/api/upgrade_plano", params);

      if (resp.data.ok) {

        toast.success('Plano alterado', {});

        // this.getContaPlano(ContaStore.obs.conta_id)

      } else {
        toast.error(resp.data.error, {});
      }

    } catch (ex) {
      toast.error('Erro ao alterar Plano, tente novamente mais tarde.', {});
    }
  }

  async handleReset2Fa(id: string) {

    try {

      let resp = await api_adm.post("/api/admin/reset-2fa", { id: id });

      if (resp.data.ok) {

        toast.success('2FA resetado com sucesso!', {});

      } else {
        toast.error(resp.data.error, {});
      }

    } catch (ex) {
      toast.error('Erro ao resetar 2FA, tente novamente mais tarde.', {});
    }

  }

  async handleliberaEmpresasSefaRetroativas(empresa_id: string, checked: boolean) {

    try {

      let data = {
        id: empresa_id,
        sefa_retroativa: checked
      }

      let resp = await api_adm.put(`/api/admin/empresa-sefa-retroativa`, data);

      return resp.data.ok

    } catch (ex) {

      toast.error("Erro ao liberar Empresa Retroativa!", {});

    }

    return false

  }

  async handleSefaErroFatal(empresa_id: string, checked: boolean) {

    try {

      let data = {
        id: empresa_id,
        sefa_bloqueio_erro_fatal: checked
      }

      let resp = await api_adm.put(`/api/admin/empresa-sefa-bloqueio-erro-fatal`, data);

      return resp.data.ok

    } catch (ex) {

      toast.error("Erro ao liberar Empresa Bloqueio Fatal!", {});

    }

    return false

  }
}

export const ContaStore = new _ContaStore();
